/*@ngInject*/
const UISetFocusDirective = function () {
    return function (scope, elem, attr) {
        scope.$on(attr.uiSetFocus, function (e) {
            elem[0].focus();
        });
    };
};

angular.module('umCore')
    .directive('uiSetFocus', UISetFocusDirective);
